/**
 * Opções de ícone (Lucide, kebab-case) e cores de atalho para formulários de workflow
 * (criar / editar). Centralizado para não duplicar listas entre modais.
 */

/** 12 cores originais + 6 tons adicionais (âmbar, ciano, violeta, lima, ardósia, rose). */
export const WORKFLOW_ACCENT_COLOR_PALETTE: readonly string[] = [
  '#111827',
  '#334155',
  '#4f46e5',
  '#2563eb',
  '#0891b2',
  '#0f766e',
  '#16a34a',
  '#ca8a04',
  '#ea580c',
  '#dc2626',
  '#db2777',
  '#7c3aed',
  '#F59E0B',
  '#06B6D4',
  '#A855F7',
  '#84CC16',
  '#64748B',
  '#E11D48',
];

/**
 * Biblioteca de ícones no picker. Nomes válidos Lucide (lucide-angular).
 * Ordem: operação / produto → comunicação → utilitários → deslocação / logística → extras.
 */
export const WORKFLOW_FORM_ICON_KEYS: readonly string[] = [
  'columns-3',
  'layout-grid',
  'folder',
  'layers',
  'briefcase',
  'file-text',
  'check-square',
  'inbox',
  'message-square',
  'settings',
  'users',
  'bug',
  'calendar',
  'camera',
  'database',
  'sparkles',
  'clipboard-list',
  'clipboard-check',
  'bell',
  'globe',
  'mail',
  'phone',
  'user',
  'lock',
  'plus',
  'search',
  'sun',
  'moon',
  'eye',
  'eye-off',
  'sliders-horizontal',
  'route',
  'car',
  'bus',
  'bike',
  'truck',
  'plane',
  'ship',
  'train-front',
  'tram-front',
  'navigation',
  'compass',
  'fuel',
  'package',
  'warehouse',
  'shopping-cart',
  'store',
  'wallet',
  'credit-card',
  'banknote',
  'wrench',
  'stethoscope',
  'hospital',
  'pill',
  'headset',
  'phone-call',
  'van',
  'tractor',
  'ambulance',
  'motorbike',
  'car-taxi-front',
  'truck-electric',
  'train-track',
  'map-pinned',
  'person-standing',
  'user-plus',
  'user-search',
  'user-cog',
  'users-round',
  'toolbox',
  'map',
  /* --- ícones adicionais --- */
  'building-2',
  'home',
  'factory',
  'rocket',
  'target',
  'flag',
  'trending-up',
  'bar-chart-2',
  'pie-chart',
  'shield',
  'shield-check',
  'key',
  'zap',
  'lightbulb',
  'star',
  'heart',
  'clock',
  'timer',
  'list-todo',
  'bookmark',
  'tag',
  'megaphone',
  'palette',
  'brain',
  'flask-conical',
  'scale',
  'gavel',
  'dollar-sign',
  'percent',
  'calculator',
  'clipboard',
  'qr-code',
  'wifi',
  'cloud',
  'cpu',
  'code',
];
